class FooterController {
  constructor() {
    this.name = 'footer';
    this.values = {
      current_year: (new Date()).getFullYear()
    };
  }
}

export default FooterController;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.controller.js